wfx = wfx || {};
wfx.ui = wfx.ui || {};
wfx.ready = wfx.ready || [];

// DOCUMENT READY
// Contains global functionality and executes all registered ready functions (wfx.ready) on document ready.
$(document).ready(function () {
    // Set BLOCK UI settings before ready functions in case BLOCK UI is used in an earlier ready function.
    $.blockUI.defaults.message = '<img src="/images/ajax-loader.gif?v=2" style="margin: 0 auto;" />';
    $.blockUI.defaults.css.background = 'none';
    $.blockUI.defaults.css.border = 'none';
    $.blockUI.defaults.css.padding = 0;
    $.blockUI.defaults.css.width = '100%';
    $.blockUI.defaults.overlayCSS.background = '#fff';
    $.blockUI.defaults.overlayCSS.opacity = 0.7;

    // Execute all defined ready functions.
    for (let i = 0; i < wfx.ready.length; i++) {
        wfx.ready[i]();
    }

    // Setup standalone mode
    if (wfx.ui.isInStandaloneMode()) {
        // Add pwa indicator class to body
        document.querySelector('body').classList.add('pwa')

        // Service worker registration
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('js/pwabuilder-sw/pwabuilder-sw.js', {
                scope: '/'
            }).then(function (reg) {
                // Service worker successfully registered
            }).catch(function (error) {
                // Service worker failed to register
            });
        }
    }

    // Setup document signature
    let sigPadCont = $('.js-signature_pad_cont');
    if (sigPadCont.length) {
        let sigPad = new wfx.ui.SignaturePad(sigPadCont);
        $('.js-signature_pad_append_sig').submit(function () {
            $(this).find('.js-signature_pad_sig_val_target').val(sigPad.getPng());
        });
    }

    // Setup Select2
    let $select2 = $('.select2');
    if ($select2.length) {
        $select2.parent().select2({
            selectionCssClass: 'form-control',
            language: 'de',
        });

        $('.js-hide_Titles span ').hide()
    }

    // Setup keep alive token
    setInterval(function() {
        $.ajax({
            url: '/keep-token-alive',
            method: 'post',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        }).then(function (result) {
            // console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
        });
    }, 1000 * 60); // every minute (1)


    // FIXME: refactor this - causes troubles...
    var $submitBtn = null;
    $('button[type="submit"]').on('click', function () {
        $submitBtn = $(this);
    });

    $("form").submit(function () {
        var $btnSubmit = $(this).find('.btn-submit');
        if($submitBtn) {
            var name = $submitBtn.attr('name');
        }
        else {
            name = $btnSubmit.attr('name');
        }

        $(this).find('.js_submit-field').attr('name', name);
        $(this).find('.js_submit-field').attr('value', 1);
        // FIXME: refactor this - causes js errors...
        $btnSubmit.prop('disabled', true);
        $submitBtn.prop('disabled', true);
    });

    // Setup block_btn: Disables the element to prevent further clicking.
    $('.js-block_btn').click(function () {
        $(this).prop('disabled', true);
    });

    // Setup refresh-page (cache reload) function.
    $('.refresh-page').click(function () {
        $('body').block();
        $('#sidebar').block();
    });
});
